import { defineMessages, useIntl } from "react-intl";

import {
  queryClient,
  MutationActions,
  QueryKeys,
  useEntityMutation,
} from "@/api/core";
import { useApi } from "@/hooks";
import { statusSchema } from "@/schemas";
import toast from "@/toast";

import { updateStatusCache } from "../utils";

const messages = defineMessages({
  unmuteSuccess: {
    id: "status.unmute.success",
    defaultMessage: "You have successfully unmuted this Truth.",
  },
  deletedTruth: {
    id: "status.error.deletedTruth",
    defaultMessage: "This Truth has been deleted and is no longer available.",
  },
});

interface Variables {
  id: string;
}

function useUnmuteStatus() {
  const api = useApi();
  const intl = useIntl();

  return useEntityMutation({
    globalQueryKey: QueryKeys.statuses.global,
    idAttributeFromVariables: "id",
    action: MutationActions.UPDATE,
    schema: statusSchema,
    mutationFn: (variables: Variables) =>
      api.post(`/api/v1/statuses/${variables.id}/unmute`),
    onMutate(variables) {
      const [prevStatus] = updateStatusCache(variables.id, () => ({
        muted: false,
      }));

      return { prevStatus };
    },
    onSuccess() {
      toast.success(intl.formatMessage(messages.unmuteSuccess));
    },
    onError(error, variables, context) {
      if (error.response?.status === 404) {
        toast.error(intl.formatMessage(messages.deletedTruth));
      }
      if (context) {
        queryClient.setQueryData(
          QueryKeys.statuses.detail(variables.id),
          context.prevStatus,
        );
      }
    },
  });
}

export { useUnmuteStatus };
